// Set to true to enable react-animate-on-scroll effects.
export const ENABLE_SCROLL_ANIMATIONS = false
